import React from 'react'

import { Link } from 'react-router-dom'
import { reverse } from 'named-urls'
import { routes } from 'routes'

import {
  Button,
  Typography,
  CircularProgress,
  makeStyles,
} from '@material-ui/core'

import * as service from 'service'
import helpers from 'helpers'
import useAuth from 'hooks/useAuth'
import useContract from 'hooks/useContract'
import useCollapse from 'hooks/useCollapse'
import styles from './styles'

const useStyles = makeStyles(styles)

const Finish = () => {
  const classes = useStyles()
  const auth = useAuth()
  const { data, toStep, reset } = useContract()
  const collapse = useCollapse()
  const [contract, setContract] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(true)
  const [error, setError] = React.useState(false)

  React.useEffect(() => {
    const createContract = async () => {
      try {
        const responseContract = await service.recurrence.contracts.create({
          customerId: data.customer.id,
          sellerId: auth.seller.id,
          sellerCode: auth.seller.code,
          contract: {
            dayExpiration:
              data.contract.payment === 'postpaid'
                ? data.contract.dayExpiration
                : null,
            urlNotification: data.contract.urlNotification,
            postPaid: data.contract.payment === 'postpaid',
            plans: collapse.data.map(item => ({
              code: item.plan.code,
              name: item.plan.name,
              price: parseFloat(item.price),
              periodicity: parseInt(item.periodicity),
              quantity: parseInt(item.quantity),
              contractPlanEntries: helpers.contractPlanEntries.normalizeSend(
                item.contractPlanEntries,
              ),
            })),
            taxes: [...data.contract.taxes.map(tax => ({ id: tax.id }))],
            settings: [
              {
                settingTag: 'days_to_overdue_invoice',
                value: data.contract.settings.daysToOverdueInvoice,
              },
              {
                settingTag: 'invoice_interval',
                value: helpers.formatNumber.formatNumberToString(
                  data.contract.settings.invoiceInterval,
                ),
              },
              {
                settingTag: 'days_to_generate_nfe',
                value: helpers.formatNumber.formatNumberToString(
                  data.contract.settings.daysToGenerateNfe,
                ),
              },
              {
                settingTag: 'generate_service_tax_invoices',
                value: data.contract.settings.generateServiceTaxInvoices,
              },
              {
                settingTag: 'fixed_tax_invoice_description',
                value: data.contract.settings.fixedTaxInvoiceDescription,
              },
            ],
          },
        })

        const responsesContractEmails = await Promise.all(
          data.contract.contractEmails.map(email =>
            service.recurrence.contractEmails.create({
              contractId: responseContract.data.contract.id,
              name: email,
              email,
            }),
          ),
        )

        setContract({
          ...responseContract.data.contract,
          contractEmails: responsesContractEmails.map(
            responseContractEmails => responseContractEmails.data.contractEmail,
          ),
        })
        setIsLoading(false)
      } catch (error) {
        setError(error)
        setIsLoading(false)
      }
    }

    createContract()
  }, [data, auth.seller.code, auth.seller.id, collapse.data])

  const handleClickTryAgain = () => {
    toStep(0)
  }

  const handleClickNew = () => {
    reset()
    collapse.reset()
  }

  const Success = () => (
    <>
      <Typography variant="h3" className={classes.title}>
        Assinatura cadastrada com sucesso!
      </Typography>
      <div className={classes.buttonGroup}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          component={Link}
          to={reverse(routes.contracts.show, {
            contractId: contract.id,
          })}
          fullWidth
        >
          Visualizar
        </Button>
        <Button className={classes.button} onClick={handleClickNew} fullWidth>
          Adicionar nova
        </Button>
      </div>
    </>
  )

  const Error = () => (
    <>
      <Typography variant="h3" className={classes.title}>
        Ops! Ocorreu algum erro!
      </Typography>
      <div className={classes.buttonGroup}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleClickTryAgain}
          fullWidth
        >
          Tentar novamente
        </Button>
        <Button
          className={classes.button}
          component={Link}
          to={routes.contracts.all}
          fullWidth
        >
          Cancelar cadastro
        </Button>
      </div>
    </>
  )

  const ShowResult = () => (error ? <Error /> : <Success />)

  return (
    <div className={classes.root}>
      {isLoading ? <CircularProgress size={40} /> : <ShowResult />}
    </div>
  )
}

export default Finish
